import { Box, Divider, Stack } from "@mui/material";
import React from "react";
import { useConfig } from "../auth";
import ProviderList from "../socialaccount/ProviderList";

/**
 * Shared chrome below auth forms: divider, social providers, optional
 * method toggle, then caller JSX (e.g. Magic Link | Forgot Password).
 */
const AlternateSignInOptions: React.FC<{
  methodToggle?: React.ReactNode;
  children?: React.ReactNode;
}> = ({ methodToggle, children }) => {
  const config = useConfig();
  const hasProviders =
    (config.data.socialaccount?.providers?.length ?? 0) > 0;
  const childItems = React.Children.toArray(children);

  if (!hasProviders && !methodToggle && childItems.length === 0) {
    return null;
  }

  return (
    <>
      <Divider sx={{ width: "100%", backgroundColor: "primary.dark", my: 2 }} />

      {hasProviders && (
        <ProviderList callbackURL="/account/provider/callback" />
      )}

      {methodToggle && <Box sx={{ mt: 2, width: "100%" }}>{methodToggle}</Box>}

      {childItems.length > 0 && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{
            mt: 2,
            width: "100%",
            "& > *": { flex: { sm: 1 }, minWidth: 0 },
          }}
        >
          {childItems}
        </Stack>
      )}
    </>
  );
};

export default AlternateSignInOptions;
